<template>
  <transition name="modal">
    <div class="modal-background" @click="close" v-show="show">
      <section class="modal-container" @click.stop>
        <h2>{{title}}</h2>
        <slot></slot>
      </section>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['show', 'title'],
  emits: ['close'],
  methods: {
    close: function() {
      this.$emit('close');
    }
  },
  mounted: function() {
    document.addEventListener('keydown', (e) => {
      if (this.show && e.key === 'Escape') {
        this.close();
      }
    })
  }
}
</script>
